import client from '../api/apiClient'
import { tokenConfig } from './'

export function filterWorkRequest (token, params) {
  return client().post(`/programmed_maintenance_change/filter_work_requests/`, {...params}, tokenConfig(token))
}
